<template>
  <div class="VIEWBUTTONS d-flex">
    <router-link
        :target="[$device.isMobileOrTablet ? '_self' : '_blank']"
        :to="{
          name: 'pro-public-profile',
          params: { serviceProviderOccupationId: publicProfileId }
    }">
      <span class="VIEWPROFILE btn-secondary btn-sm m-l-auto m-r-0">
        <a class="VIEWPROFILETEXT">
          View Profile
        </a>
      </span>

    </router-link>
    <span @click="$emit('showInfoModal')">
      <a class="VIEWPROFILETEXT m-l-2">
        View Reviews
      </a>
    </span>

  </div>
</template>

<script>
import formatNumber from '@/filters/format-number';

export default {
  name: 'pro-credentials',
  props: {
    publicProfileId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    credentials () {
      return this.$store.getters['jobrequest/matches/publicProfileCredentials'](this.publicProfileId);
    },
  },
  methods: {
    formatNumber,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .VIEWBUTTONS{
    position: absolute;
    bottom: 5px;
  }

  .VIEWPROFILE{
    height: 18px;
    width: 53px;
    border-radius: 2px;
  }
  .VIEWPROFILETEXT{
    font-size: 8px;
    font-weight: 700;
    color: #F96302;
  }

  .CREDENTIAL {

    @include margin-right(2);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }

  .CREDENTIAL:last-child {
    @include margin-right(0);
  }
</style>
